<script setup lang="ts">
interface UserTagProps {
  label: string
  color?: 'Blue' | 'Cyan' | 'Gray' | 'Green' | 'Red' | 'Yellow' | undefined
}

const props = defineProps<UserTagProps>()

const getColorClasses = (color: UserTagProps['color']): string => {
  switch (color) {
    case 'Blue':
      return 'bg-lochmara-100 text-lochmara-600'
    case 'Cyan':
      return 'bg-seagull-100 text-seagull-700'
    case 'Gray':
      return 'bg-black-100 text-black-700'
    case 'Green':
      return 'bg-keppel-100 text-keppel-800'
    case 'Red':
      return 'bg-radical_red-100 text-radical_red-500'
    case 'Yellow':
      return 'bg-lightning_yellow-100 text-lightning_yellow-800'
    case undefined:
    default:
      return 'bg-seagull-100 text-black-900'
  }
}

defineSlots<{
  default(): string
}>()
</script>

<template>
  <div
    class="items-center justify-center gap-2.5 whitespace-nowrap rounded-[2rem] px-2 py-0.5 text-xs hc:outline hc:outline-1 hc:-outline-offset-1 hc:outline-current"
    :class="getColorClasses(props.color)"
  >
    {{ props.label }}
    <slot></slot>
  </div>
</template>
